import { useEffect } from 'react';
import { useQueryParams } from './useQueryParams';
import * as api from '@src/utils/mmc-api/api';
import { sendEvent } from '@src/utils/gtag';

export function useQrTracking(): void {
  const { get, remove } = useQueryParams();

  useEffect(() => {
    const source = get('qr');
    if (!source) return;

    api.trackEvent('qr_scan', source);
    sendEvent({ name: 'qr_scan', category: 'engagement', label: source, value: undefined });

    remove('qr');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
